import { useWeb3React } from '@web3-react/core';
import useSWR from 'swr';
import { verifyChainConfig } from '../../helpers';
import { CHAIN_INFO } from '../../config/constants';
import { formatUnits } from 'ethers/lib/utils';

const useNativeCurrency = () => {
    const { library, account, chainId } = useWeb3React();

    const { data, error } = useSWR(
        library && account && chainId
            ? ['nativeCurrency', library, account, chainId]
            : null,
        async (_, library, account, chainId) => {
            if (!verifyChainConfig(chainId)) return;

            const balance = await library.getBalance(account);

            const nativeCurrencyInfo = CHAIN_INFO[chainId].nativeCurrency;

            return {
                ...nativeCurrencyInfo,
                balance: formatUnits(balance, nativeCurrencyInfo.decimals),
            };
        },
        {
            refreshInterval: 5000,
            dedupingInterval: 5000,
        }
    );

    return {
        nativeCurrency: data,
        isLoading: !data && !error,
        error,
    };
};

export default useNativeCurrency;
